/**
 * Catálogo estadual exibido no modal «Fontes ativas» — espelha
 * `services/regulatory/src/agency_catalog_filters.py` para a UI não depender só do deploy do regulatory.
 */

export const BRAZIL_UF_KEYS = new Set([
  'ac', 'al', 'ap', 'am', 'ba', 'ce', 'df', 'es', 'go', 'ma', 'mt', 'ms', 'mg', 'pa', 'pb', 'pr', 'pe', 'pi',
  'rj', 'rn', 'rs', 'ro', 'rr', 'sc', 'sp', 'se', 'to',
]);

const JUNK_UF = new Set(['dc', 'md', 'mj', 'mp']);

const FEDERAL_HEAD_JUNCTION = new Set([
  'ana', 'anm', 'cgen', 'cnzu', 'conabio', 'conama', 'conaveg', 'dou', 'federal', 'ibama', 'icmbio', 'jbrj',
  'mapa', 'mma', 'ms', 'mtur', 'sbio',
]);

/** UFs com lista fechada de chaves `agencies.key` (minúsculas). */
const STATE_PRIMARY_KEYS_BY_UF: Record<string, Set<string>> = {
  ms: new Set(['semade-ms', 'imasul-ms']),
  pr: new Set(['iap-pr', 'iat-pr']),
};

export function isStateCatalogSourceRow(s: { uf?: string | null; key?: string | null; name?: string | null }): boolean {
  const uf = String(s?.uf ?? '').trim().toLowerCase();
  if (!uf || !BRAZIL_UF_KEYS.has(uf) || JUNK_UF.has(uf)) return false;
  const name = String(s?.name ?? '');
  if (name.includes('/')) return false;
  const k = String(s?.key ?? '').trim().toLowerCase();
  if (!k) return false;
  const m = /^([a-z0-9]+)-([a-z]{2})$/.exec(k);
  if (m) {
    const head = m[1];
    if (FEDERAL_HEAD_JUNCTION.has(head)) return false;
  }
  const allow = STATE_PRIMARY_KEYS_BY_UF[uf];
  if (allow) return allow.has(k);
  return true;
}

/** Remove lixo de UF/nome/chave e zera contagens (monitoramento estadual ainda não consolidado). */
export function filterAndZeroStateSourceSummaries<T extends object>(rows: readonly T[] | T[] | null | undefined): T[] {
  return (rows ?? []).filter((r) => isStateCatalogSourceRow(r as { uf?: string | null; key?: string | null; name?: string | null })).map(
    (r) =>
      ({
        ...r,
        total_normas: 0,
        leis: 0,
        decretos: 0,
        resolucoes: 0,
        outras: 0,
      }) as T,
  );
}
